export const prefix = process.env.NODE_ENV === "development" ? '/api' : ''
export const api =  process.env.NODE_ENV === "development" ? '' : 'https://local.vrmaker.vip:37086'
// export const api =  process.env.NODE_ENV === "development" ? '' : 'http://192.168.33.141'
